/* Component-specific styles only */
:host {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  padding: var(--padding-xl);
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--padding-xl) var(--margin-xl);
  max-width: 1200px;
  margin: 0 auto;
}
.logo {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
}
.auth-form {
  width: 100%;
  max-width: 768px;
  background: var(--color-bg-primary);
  border: var(--border);
  border-radius: var(--border-radius);
  padding: var(--margin-xl);
}
.auth-form h2 {
  margin: 0 0 var(--margin-xl);
  font-size: var(--font-size-xl);
  text-align: center;
}
.auth-form button {
  width: 100%;
  padding: var(--padding-l);
  background: var(--color-bg-accent);
  color: var(--color-text-inverse);
  border: none;
  border-radius: var(--border-radius);
  font-size: var(--font-size);
  cursor: pointer;
  margin-top: var(--margin-xl);
}
.auth-form button:hover {
  background: var(--color-text-accent);
}

.auth-form button:disabled {
  background: var(--color-disabled);
  cursor: not-allowed;
}
.mode-switcher {
  text-align: center;
  margin-top: var(--margin-xl);
  font-size: var(--font-size-s);
}
.mode-switcher a {
  color: var(--color-bg-accent);
  cursor: pointer;
  text-decoration: none;
}
.mode-switcher a:hover {
  text-decoration: underline;
}
@media (max-width: 768px) {
  .logo {
    font-size: var(--font-size-l);
  }
  .auth-form {
    display: block;
    margin-top: var(--margin-xl);
    box-sizing: border-box;
  }
  .auth-form h2 {
    font-size: var(--font-size-l);
    margin-bottom: var(--padding-l);
  }
  .auth-form button {
    width: 45%;
    margin-left: auto;
    display: block;
    padding: var(--padding);
    margin-top: var(--padding-l);
  }
  .mode-switcher {
    margin-top: var(--padding-l);
  }
}
